import { render, staticRenderFns } from "./advertised.vue?vue&type=template&id=a4bd5a7a&scoped=true&"
import script from "./advertised.vue?vue&type=script&lang=js&"
export * from "./advertised.vue?vue&type=script&lang=js&"
import style0 from "./advertised.vue?vue&type=style&index=0&id=a4bd5a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bd5a7a",
  null
  
)

export default component.exports